import React from "react";
import { toFormatPrice } from "../../../common/helpers/function";

/* -----------------------------------------------------------------------------
 * Stock Adjustment — expandable sub-table (line items of one adjustment).
 * Built from the getSADetails response ( { data: { _id, lines:[...], summary } } ).
 *   endpoint: api/v1/Inventory/stockAdjustment/getSADetails  body: { adjustment_id }
 * ---------------------------------------------------------------------------*/
export const Stockadjustmentdetails = (
  prioritydata,
  setImageid,
  setProductmodaldata,
  t
) => {
  const base_url_assets = process.env.REACT_APP_BASE_ASSETS_URL;
  const data = prioritydata?.data;
  const rowId = data?._id;
  const lines = Array.isArray(data?.lines) ? data.lines : [];
  const summary = data?.summary || {};

  return (
    <React.Fragment>
      {prioritydata?.code === 200 ? (
        <tr
          className="common-sub-table-wrap add-row remove"
          id={"common-table-sub-row" + rowId}
        >
          <td colSpan="13">
            <table
              id={"data_table_set_" + rowId}
              className="common-table common-sub-table"
            >
              <thead>
                <tr>
                  <th className="col-highlight">#</th>
                  <th className="col-highlight">{t("img.")}</th>
                  <th className="col-highlight">{t("Product Name")}</th>
                  <th className="col-highlight">{t("SKU")}</th>
                  <th>{t("Stock ID")}</th>
                  <th>{t("Metal")}</th>
                  <th>{t("Stone")}</th>
                  <th>{t("Size")}</th>
                  <th>{t("Current Qty")}</th>
                  <th>{t("Adj Qty")}</th>
                  <th>{t("Amount")}</th>
                  <th>{t("Reason")}</th>
                  <th>{t("Remark")}</th>
                </tr>
              </thead>
              <tbody>
                {lines.map((result, key) => (
                  <tr key={result?.line_id || key}>
                    <td className="col-highlight">
                      {result?.serial ? result?.serial : key + 1}
                    </td>
                    <td className="col-highlight">
                      <div
                        className="table-pro-img"
                        onClick={() => setImageid(result?.po_product_id)}
                        data-bs-toggle="modal"
                        data-bs-target="#ProductViewModal"
                      >
                        <img src={result?.image} alt="" />
                      </div>
                    </td>
                    <td className="po-no col-highlight">
                      <div className="tooltip-area-up">
                        <div className="truncate-text-subtable">{result?.product_name ? result?.product_name : "-"}</div>
                        {result?.product_name && <span className="tooltip-area-up-text text-white">{result?.product_name}</span>}
                      </div>
                    </td>
                    <td
                      className="po-no col-highlight link-color"
                      data-bs-toggle="modal"
                      onClick={() => setProductmodaldata(result)}
                      data-bs-target="#ProductInfoModal"
                    >
                      {result?.SKU ? result?.SKU : "-"}
                    </td>
                    <td className="col-highlight">
                      <span className="red-highlight">
                        {result?.stock_id ? result?.stock_id : "-"}
                      </span>
                    </td>
                    <td>{result?.metal_name ? result?.metal_name : "-"}</td>
                    <td>{result?.stone_name ? result?.stone_name : "-"}</td>
                    <td>{result?.size_name ? result?.size_name : "-"}</td>
                    <td>
                      {typeof result?.total_qty_at_create !== "undefined"
                        ? result?.total_qty_at_create
                        : "0"}
                    </td>
                    <td>{result?.adjust_qty ? result?.adjust_qty : "0"}</td>
                    <td>
                      {typeof result?.price !== "undefined"
                        ? toFormatPrice(result?.price, { addSymbol: true })
                        : "-"}
                    </td>
                    <td>{result?.reason ? result?.reason : "-"}</td>
                    <td className="text-center">
                      {result?.remark ? result?.remark : "-"}
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr>
                  <td />
                  <td />
                  <td />
                  <td />
                  <td />
                  <td />
                  <td />
                  <td />
                  <td />
                  <td>
                    {typeof summary?.total_adj_qty !== "undefined"
                      ? summary?.total_adj_qty
                      : ""}
                  </td>
                  <td>{summary?.total_amount ? summary?.total_amount : ""}</td>
                  <td />
                  <td />
                </tr>
              </tfoot>
            </table>
          </td>
        </tr>
      ) : (
        ""
      )}
    </React.Fragment>
  );
};
